import { createBrowserRouter } from 'react-router'

import { getAppRoutes } from './routes'

export function getAppRouter(params) {
  return createBrowserRouter(getAppRoutes(params))
}
